import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
// import Select from "react-select";
import Select from "@mui/material/Select";
import Model from "../Model";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  gCouncilList,
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
} from "../../Config";

const AddSubAdminModel = ({
  SingleEntryLoading,
  postAddUser,
  setOpenUploadModel,
  selectedRegionDetails,
}) => {
  const [uploadFile, setUploadFile] = useState("");
  const [districtsList, setDistricts] = useState([]);
  const { t, i18n } = useTranslation();
  const [regionLabel, setRegionLabel] = useState("");
  const [region, setRegion] = useState("");
  const [districtLabel, setDistrictLabel] = useState("");
  const [district, setDistrict] = useState("");
  const [councilLabel, setCouncilLabel] = useState("");
  const [council, setCouncil] = useState("");
  const [councilList, setCouncilList] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");

  const handleRegionChange = (event) => {
    const regionId = event.target.value;
    setSelectedRegion(regionId);

    setSelectedDistrict("");
  };

  const InitialValues = {
    region: "",

    district: "",

    council: "",
  };
  console.log(selectedRegionDetails.rlist);
  const SubmitHandler = (values) => {
    console.log(values);
    if (!values.region) {
      toast.error("Please select a region first.");
      return;
    }

    if (!values.district) {
      toast.error("Please select a district.");
      return;
    }
    if (!values.council) {
      toast.error("Please enter a council.");
      return;
    }
    postAddUser(values);
  };

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add Council</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              {/* <CombineInputGroup> */}
              <InputGroup>
                <Label htmlFor="region">{t("c_region")}</Label>
                <FieldWrapper $select={true}>
                  <Field required name="region" id="region" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full"
                        {...props.field}
                        value={selectedRegion}
                        onChange={(e) => {
                          handleRegionChange(e);
                          props.field.onChange(e);
                        }}
                      >
                        <MenuItem value="N/A" disabled>
                          Select Region
                        </MenuItem>
                        {selectedRegionDetails?.rlist?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="district">{t("C_District")}</Label>
                <FieldWrapper $select={true}>
                  <Field
                    required
                    name="district"
                    id="district"
                    autoComplete="off"
                  >
                    {(props) => (
                      <Select
                        className="w-full h-full"
                        {...props.field}
                        value={selectedDistrict}
                        onChange={(e) => {
                          setSelectedDistrict(e.target.value);
                          props.field.onChange(e);
                        }}
                      >
                        {!props.form.values.region && (
                          <MenuItem disabled>
                            Please Select Region First
                          </MenuItem>
                        )}
                        {/* <MenuItem value="N/A" disabled>
                          Select District
                        </MenuItem> */}
                        {props.form.values.region &&
                          selectedRegionDetails?.dlist
                            ?.filter((item) => item.region == selectedRegion)
                            .map((item) => (
                              <MenuItem key={item?.id} value={item?.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                        {props.form.values.region &&
                          selectedRegionDetails?.dlist?.filter(
                            (item) => item.region == selectedRegion
                          ).length === 0 && (
                            <MenuItem disabled>
                              No districts available for this region
                            </MenuItem>
                          )}
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="council">Council Name</Label>
                <FieldWrapper>
                  <Field
                    name="council"
                    id="council"
                    autoComplete="off"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;

export default AddSubAdminModel;
